import { render, staticRenderFns } from "./ServicesModule.vue?vue&type=template&id=6f4e8750&"
import script from "./ServicesModule.vue?vue&type=script&lang=js&"
export * from "./ServicesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports